/** @jsx React.DOM */'use strict';

var assign 	= require('object-assign');
var React 	= require('react');

var logger 	= require('../../utils/logger.js');

var Actions = require('../actions/equipment-search-actions.js');
var Store 	= require('../stores/equipment-search-store.js');

var tgApi = require('../../api/tg-api.js');

function getFacetValue(navigatedFacet) {
	return navigatedFacet !== null ? navigatedFacet.value : null;
}

function getFilterRequest(navState, selectedValues) {
	var filterRequest = {
		'baseSearchContext': navState.baseSearchContext,
		'manufacturer': getFacetValue(navState.navigatedMake),
		'range': getFacetValue(navState.navigatedRange),
		'rating': getFacetValue(navState.navigatedMagazineRating),
		'minPrice': getFacetValue(navState.minPrice),
		'maxPrice': getFacetValue(navState.maxPrice),
		'searchContext': navState.searchContext,
		'searchTerm': navState.searchTerm,
		'sortOption' : getFacetValue(navState.selectedSortOption)
	};

	if (selectedValues) {
		assign(filterRequest, selectedValues);
	}

	return filterRequest;
}

function loadInitialData(navState) {
	var filterRequest = getFilterRequest(navState);
	Actions.updateFilters(filterRequest);
}

var view = React.createClass({
	getInitialState: function () {
		return Store.getState();
	},

	componentWillMount: function () {
		Store.addChangeListener(this.onStoreChange);
		loadInitialData(this.props.navstate);
	},

	componentWillUnmount: function () {
		Store.removeChangeListener(this.onStoreChange);
	},

	onStoreChange: function () {
		this.setState(Store.getState());
	},

	render: function () {

		var navstate = this.props.navstate;
		var state = this.state;

		logger.debug({
			view: 'Equipment Search',
			message: 'Render',
			state: state
		});

		var makeListDisabled = state.isLoading || (state.makeItems.length == 0 && state.navigatedMake == null) || (state.navigatedMake != null);
		var rangeListDisabled = state.isLoading || state.rangeItems.length == 0;

		var minPriceDisabled = state.isLoading;
		var maxPriceDisabled = state.isLoading;
		var searchTermDisabled = state.isLoading;

		var magazineRatingDisabled = state.isLoading || (state.magazineRatingItems.length == 0 && state.navigatedMagazineRating == null) || state.navigatedMagazineRating != null;

		var sortDisabled = state.isLoading;

		var makeDefaultText = makeListDisabled ? 'Loading...' : 'Select a make';

		var rangeDefaultText = '';

		var updateButtonText = state.totalResults > 0 ? 'Update results' : 'No matching results found';

		var magazineRatingDefaultText = '',
			minPriceDefaultText = '',
			maxPriceDefaultText = '',
			sortDefaultText = '';

		if (state.isLoading) {
			rangeDefaultText = 'Loading...'
			magazineRatingDefaultText = 'Loading...'
			minPriceDefaultText = 'Loading...';
			maxPriceDefaultText = 'Loading...';
			makeDefaultText = 'Loading...';
			sortDefaultText = 'Loading...';
		} else {
			rangeDefaultText = 'Select a range';
			magazineRatingDefaultText = 'Select a magazine rating';
			minPriceDefaultText = 'Min £';
			maxPriceDefaultText = 'Max £';
			makeDefaultText = 'Select a make';
			sortDefaultText = 'Most Recent';
		}

		var navigatedMake = state.navigatedMake != null ? state.navigatedMake.value : null;
		var navigatedRange = state.navigatedRange != null ? state.navigatedRange.value : null;
		var navigatedMagazineRating = state.navigatedMagazineRating != null ? state.navigatedMagazineRating.value : null;
		var selectedSortOption = state.selectedSortOption != null ? state.selectedSortOption.value : null;

		var makeListItems, rangeListItems, minPriceItems, maxPriceItems, magazineRatingItems, sortOptionItems;

		var totalResults = state.totalResults;

		if (state.makeItems) {
			makeListItems = state.makeItems.map(function (make) {
				return <option key={make.value} value={make.value}>{make.displayText} ({make.count})</option>;
			});
		}

		if (state.navigatedMake != null) {
			makeListItems = <option disabled="disabled" key={state.navigatedMake.value} value={state.navigatedMake.value}>{state.navigatedMake.displayText}</option>;
		}

		if (state.rangeItems) {
			rangeListItems = state.rangeItems.map(function (range) {
				return <option key={range.value} value={range.value}>{range.displayText} ({range.count})</option>;
			});
		}

		if (state.navigatedRange != null) {
			rangeListItems = <option key={state.navigatedRange.value} value={state.navigatedRange.value}>{state.navigatedRange.displayText}</option>;
		}

		if (state.magazineRatingItems) {
			magazineRatingItems = state.magazineRatingItems.map(function (magazineRatingItem) {
				return <option key={magazineRatingItem.value} value={magazineRatingItem.value}>{magazineRatingItem.displayText} ({magazineRatingItem.count})</option>;
			});
		}

		if (state.navigatedMagazineRating != null) {
			magazineRatingItems = <option key={state.navigatedMagazineRating.value} value={state.navigatedMagazineRating.value}>{state.navigatedMagazineRating.displayText}</option>;
		}


		minPriceItems = state.pricePoints.map(function (price) {
			if ((state.maxPrice != null && price < parseInt(state.maxPrice.value,10)) || (state.maxPrice == null)) {
				if (state.minPrice && (price === state.minPrice.value)) {
					return <option selected="selected" key={price} value={price}>£{price}</option>;
				} else {
					return <option key={price} value={price}>£{price}</option>;
				}
			} 
		});

		maxPriceItems = state.pricePoints.map(function (price) {
			if ((state.minPrice != null && price > parseInt(state.minPrice.value,10)) || (state.minPrice == null)) {
				if (state.maxPrice && (price === state.maxPrice.value)) {
					return <option selected="selected" key={price} value={price}>£{price}</option>;
				} else {
					return <option key={price} value={price}>£{price}</option>;
				}
			} 
		});

		sortOptionItems = state.sortOptions.map(function (option) {
			var key = Object.keys(option)[0];
			var value = option[key];
            if (navstate.selectedSortOption && (value === navstate.selectedSortOption)) {
				return <option selected="selected" key={key} value={value}>{key}</option>;
			} else {
				return <option key={key} value={value}>{key}</option>;
			}
		});

		return (
			<div>
				<form className="search-filters panel equipment-search search-filters equipment-search__form  form" onSubmit={this.submitForm}>
					<div className="row">
						<div className="column large-6 font-small show-for-large-up">
							<p><strong>{navstate.heading}</strong></p>
						</div>
						<div className="column large-6 text-right font-small">
							<p className="search-filters__count">
								{state.totalResults === 1 ? <span><strong className="search-filters__count__value">{totalResults}</strong> matching review found</span> : <span><strong className="search-filters__count__value">{totalResults}</strong> matching reviews found</span>}				
							</p>
						</div>
					</div>
					<div className="row">
						<div className="column large-4">
							<select disabled={makeListDisabled} value={navigatedMake} className="form__list" onChange={this.selectMake}>
								<option value="">{makeDefaultText}</option>
								{makeListItems}
							</select>
							{state.navigatedMake == null ? null : <span className="equipment-search__clear-filter equipment-search__clear-filter--select" onClick={this.clearMake}>X</span>}				
						</div>
						<div className="column large-4">
							<select disabled={rangeListDisabled} value={navigatedRange} className="form__list" onChange={this.selectRange}>
								<option value="">{rangeDefaultText}</option>
								{rangeListItems}
							</select>		
							{state.navigatedRange == null ? null : <span className="equipment-search__clear-filter equipment-search__clear-filter--select" onClick={this.clearRange}>X</span>}				
						</div>
						<div className="column large-4">
							<select disabled={magazineRatingDisabled} value={navigatedMagazineRating} className="form__list" onChange={this.selectRating}>
								<option>{magazineRatingDefaultText}</option>
								{magazineRatingItems}
							</select>
							{state.navigatedMagazineRating == null ? null : <span className="equipment-search__clear-filter equipment-search__clear-filter--select" onClick={this.clearRating}>X</span>}				
						</div>
					</div>
					<div className="row">
						<div className="column large-4">
							<div className="search-filters__entry search-filters__entry--double">
								<select disabled={minPriceDisabled} className="search-filters__select" onChange={this.selectMinPrice}>
									<option>{minPriceDefaultText}</option>
									{minPriceItems}
								</select>
								<span className="search-filters__to-text text-center font-small">to</span>
								<select disabled={maxPriceDisabled} className="search-filters__select" onChange={this.selectMaxPrice}>
									<option>{maxPriceDefaultText}</option>
									{maxPriceItems}
								</select>
							</div>
						</div>
						<div className="column large-4 large-pull-4">
							<input className="searchTermInput" disabled={searchTermDisabled} type="text" value={state.isLoading ? 'Loading...' : state.searchTerm} placeholder="Enter a keyword" onBlur={this.updateSearchTerm} onMouseLeave={this.updateSearchTerm} onKeyPress={this.updateSearchTermKeyPress} />
							{state.searchTerm == null ? null : <span className="equipment-search__clear-filter" onClick={this.clearSearchTerm}>X</span>}				
						</div>
					</div>
					<a href="#" className="search-filters__clear-filters equipment-search__clear-filters font-small" onClick={this.clearFilters}>
						<span className="icon fi-loop"></span>
						<span>Clear all filters</span>
					</a>
					<button type="submit" disabled={!totalResults || state.isLoading} className="update search-filters__update-results button radius" onClick={this.submitForm}>
						{updateButtonText}
					</button>
				</form>
				<div className="row">
					<div className="column large-7 xxlarge-8"></div>
					<div className="equipment-search__sort-options column large-5 xxlarge-4">
						<div className="row">
							<div className="column small-4 large-3">
								<label className="inline">Sort by:</label>
							</div>
							<div className="column small-8 large-9">
								<select disabled={sortDisabled} id="sortBy" onChange={this.selectSortOption}>
									<option value="">{sortDefaultText}</option>
									{sortOptionItems}
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	},

	selectMake: function (e) {
		var make = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'manufacturer': make,
			'range': ''
		});
		Actions.updateFilters(filterRequest);
	},

	selectRange: function (e) {
		var range = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'range': range
		});
		Actions.updateFilters(filterRequest);
	},

	selectMinPrice: function (e) {
		var minPrice = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'minPrice': minPrice
		});
		Actions.updateFilters(filterRequest);
	},

	selectMaxPrice: function (e) {
		var maxPrice = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'maxPrice': maxPrice
		});
		Actions.updateFilters(filterRequest);
	},

	selectRating: function (e) {
		var rating = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'rating': rating
		});
		Actions.updateFilters(filterRequest);
	},

	selectSortOption: function (e) {
		var sortOption = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'sortOption': sortOption
		});
		$('.equipment-search').find('input, select, button').attr('disabled','disabled');
		$('.equipment-results').fadeOut(1000);
		tgApi.getEquipmentData(function(data){
			window.location = data.searchResultsUrl;
		},
		function() {
			console.log('API call failed for some reason');
		},
		null, 
		filterRequest);
	},

	updateSearchTerm: function (e) {
		if (!this.state.isLoading) {
			var searchTerm = $(e.target).val();
			if (searchTerm !== '' && searchTerm !== this.state.searchTerm) {
				var filterRequest = getFilterRequest(this.state, {
					'searchTerm': searchTerm
				});
				Actions.updateFilters(filterRequest);
			}
		}
	},

	updateSearchTermKeyPress: function (e) {
		if (!this.state.isLoading && e.key === 'Enter') {
			var searchTerm = $(e.target).val();
			if (searchTerm !== '' && searchTerm !== this.state.searchTerm) {
				var filterRequest = getFilterRequest(this.state, {
					'searchTerm': searchTerm
				});
				Actions.updateFilters(filterRequest);
			}
		}
	},

	submitForm: function (e) {
		e.preventDefault();
		if (!this.state.isLoading) {
			Actions.submitForm(this.state.searchResultsUrl);
		}
	},

	clearFilters: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'manufacturer': '',
			'range': '',
			'rating' : '',
			'minPrice' : '',
			'maxPrice' : '',
			'searchTerm' : ''

		});
		Actions.updateFilters(filterRequest);
	},

	clearMake: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'manufacturer': '',
			'range': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearRange: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'range': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearRating: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'rating': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearSearchTerm: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'searchTerm': ''
		});
		Actions.updateFilters(filterRequest);
	}

});

module.exports = view;